//import { createSelector } from 'reselect';

const getTasks = state => state.tasks;

export { getTasks };
